import React, { FC } from 'react';
import { Text } from 'react-native';
import { font } from '@styles/fonts';
import { LinkStatus } from '@interfaces/search';
import CommonLinkText from '@v2/context/ProductionBatch/linkText';
import LinkedInfo from '@v2/context/ProductionBatch/tile/components/LinkedInfo';
import { LinkTextProps } from '@v2/pages/batch/details/modules/batch/interfaces';

export const LinkText: FC<LinkTextProps> = ({ C, linkStatus, links, ncFileStatus, isWithERP, fontType = 'Body', color }) => {
  if (linkStatus === LinkStatus.PARTIAL_LINK) {
    return <LinkedInfo {...{ links, ncFileStatus, C, isWithERP, hovered: false, fontType, color }} />;
  }

  if (linkStatus === LinkStatus.SINGLE_LINK) {
    return <Text style={[font.Body, { color: C(color ?? 'Label/Light/Tertiary') }]}>{links?.[0]?.productionOrderNumber}</Text>;
  }

  return <CommonLinkText {...{ linkStatus, ncFileStatus, fontType, color }} />;
};
